import AsyncSelect, {
  Option,
  type AsyncSelectBaseProps,
} from "@/components/AsyncSelect";
import { useTranslation } from "react-i18next";
import { forwardRef } from "react";
import appConfiguration from "@/components/cfg/AppCfg";
import { FetchListRequest } from "@/services/api";
import { RoleBasedProjectSettlementType } from "../service/settlementType";

interface SettlementTypeSelectProps<T extends string>
  extends AsyncSelectBaseProps {
  className?: string;
  inDialog?: boolean;
  settlementTypeService: {
    getList(
      fetchParams?: FetchListRequest<RoleBasedProjectSettlementType[]>,
    ): Promise<T[]>;
  };
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, SettlementTypeSelectProps<string>>(
  function SettlementTypeSelect(
    { value, settlementTypeService, defaultItem, ...props },
    ref,
  ) {
    const { t } = useTranslation();

    return (
      <AsyncSelect
        queryKey={["settlementType"]}
        queryFn={async () => {
          const list = await settlementTypeService.getList({
            limit: appConfiguration.selectComponentsPaginationLimit,
          });
          return {
            items: list.map((item) => ({
              id: item,
              name: t(`settlementType.${item}`),
            })) as Option[],
            count: list.length,
          };
        }}
        placeholder={t("settlementType.placeholder")}
        loadingLabel={t("settlementType.loading")}
        {...props}
        value={value ? value.toString() : undefined}
        ref={ref}
        enableFilter={false}
        defaultItem={defaultItem}
      />
    );
  },
);
